<template>
  <CFooter>
    <div></div>
    <div class="ms-auto">
      <span class="text-muted">
        <small> &copy; 2022-{{ new Date().getFullYear() }} Skjall</small>
      </span>
      <span class="text-muted ms-3">
        <small>v{{ version }}</small>
      </span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      // Baked in by Vite at build time, see vite.config.js.
      version: __APP_VERSION__,
    }
  },
}
</script>
